/* eslint-disable vue/valid-v-slot */
import { has, isEmpty, forIn, keyBy } from 'lodash-es'
import { Task, Teacher, Staff } from '@/plugins/api'
import alert from '@/plugins/alert'

export default {
  namespaced: true,
  state: {
    tasks: [],
    contributors: {} // Danh sách những người tham gia công việc
  },
  actions: {
    /**
     * Hàm lấy tất ra tất cả các task trong database theo phân quyền login user
     */
    async fetchTasks({ commit }, options) {
      const tasks = await Task.fetch({ ...options, _limit: -1 })
      if (tasks) {
        commit('changeTasks', tasks)
      }
      return tasks
    },
    /**
     * Hàm lấy ra dữ liệu 1 task theo ID
     */
    async fetchTaskByID({ commit, state }, taskID) {
      try {
        const taskData = await Task.fetchOne(taskID)
        if (taskData) {
          const tasks = state.tasks.map(task => {
            if (task.id === taskData.id) {
              return {
                ...taskData
              }
            } else {
              return task
            }
          })
          commit('changeTasks', tasks)
          return taskData
        } else {
          alert.error('Lấy thông tin công việc thất bại!')
          return null
        }
      } catch (error) {
        console.error(error)
      }
      return null
    },
    /**
     * Hàm lấy về danh sách những người có thể tham gia giao việc và nhận việc
     * Bao gồm Giáo viên và nhân viên trung tâm
     */
    async fetchContributors({ commit }) {
      const [teachers, staffs] = await Promise.all([
        Teacher.fetch({ status: 'active', _limit: -1 }),
        Staff.fetch({ status: 'active', _limit: -1 })
      ])
      const contributors = {}
      if (teachers && teachers.length) {
        contributors.teachers = [...teachers]
      }
      if (staffs && staffs.length) {
        contributors.staffs = [...staffs]
      }
      commit('changeContributors', contributors)
    },
    /**
     * Hàm tạo mới task
     */
    async createTask({ state, commit }, taskData) {
      try {
        const task = await Task.create({
          title: taskData.title,
          content: taskData.content,
          creator: taskData.creator,
          receivers: taskData.receivers,
          category: taskData.category,
          status: taskData.status,
          startTime: taskData.startTime,
          endTime: taskData.endTime
        })
        if (task) {
          alert.success('Tạo công việc Thành Công!')
          const tasks = [
            ...state.tasks,
            {
              ...task
            }
          ]
          commit('changeTasks', tasks)
          return task
        } else {
          alert.error('Tạo công việc thất bại!')
        }
      } catch (error) {
        alert.error('Tạo công việc thất bại!')
        console.error(error)
      }
    },
    /**
     * Hàm cập nhật task
     */
    async updateTask({ state, commit }, { id, ...updateTaskData }) {
      try {
        const updatedTask = await Task.update(id, updateTaskData)
        if (updatedTask) {
          const tasks = state.tasks.map(task => {
            if (task.id === updatedTask.id) {
              return {
                ...updatedTask
              }
            } else {
              return task
            }
          })
          commit('changeTasks', tasks)
          alert.updateSuccess('công việc')
        } else {
          alert.updateError('Cập nhật công việc thất bại')
        }
      } catch (error) {
        alert.updateError('Cập nhật công việc thất bại')
        console.error(error)
      }
    },
    /**
     * Hàm xóa task
     * Xóa task bằng cách cập nhật trạng thái task từ active về deleted
     */
    async deleteTask({ state, commit }, id) {
      try {
        await Task.remove(id)
        alert.deleteSuccess('công việc')
        const tasks = state.tasks.filter(task => task.id !== id)
        commit('changeState', { tasks })
      } catch (error) {
        alert.deleteError('Xóa công việc thất bại')
        console.error(error)
      }
    }
  },
  mutations: {
    changeTasks(state, newTasks) {
      state.tasks = newTasks
    },
    changeContributors(state, newContributors) {
      state.contributors = newContributors
    }
  },
  getters: {
    /**
     * Trả về danh sách các task có thể kéo thả được
     * Các task mà user đăng nhập có tham gia
     */
    dragableTasks() {},
    /**
     * Trả về danh sách receivers dùng cho lựa chọn người nhận việc
     * trong v-autocomplete mục Add Task và Update Task
     */
    receiversForSelection(state) {
      let receiverList = []
      if (has(state.contributors, 'teachers') && !isEmpty(state.contributors.teachers)) {
        if (receiverList.length) {
          receiverList = [...receiverList, { divider: true }]
        }
        const teachers = state.contributors.teachers.map(teacher => ({ ...teacher, contributorType: 'teacher' }))
        receiverList = [...receiverList, { header: 'Giáo viên' }, ...teachers]
      }
      if (has(state.contributors, 'staffs') && !isEmpty(state.contributors.staffs)) {
        if (receiverList.length) {
          receiverList = [...receiverList, { divider: true }]
        }
        const staffs = state.contributors.staffs.map(teacher => ({ ...teacher, contributorType: 'staff' }))
        receiverList = [...receiverList, { header: 'Nhân viên' }, ...staffs]
      }
      return receiverList
    },
    /**
     * Trả về Object chứa các contributors
     * với key là userID của contributor đó
     */
    contributorsByID(state) {
      let contributors = []
      forIn(state.contributors, value => {
        contributors = [...contributors, ...value]
      })
      return keyBy(contributors, 'user')
    }
  }
}
